<template>
	<form ref="form" method="post" class="mb-3 login-pwd-reset">
		<div class="input-unit" data-validate="mail">
			<input
				type="email"
				name="email"
				autocomplete="email"
				:id="_uid"
				v-model="email"
				data-testing="guest-login-input"
				class="guest-login-mail-input"
				@input="checkExistingCustomer"
				autofocus
			/>
			<label :for="_uid">{{ $translate("Ceres::Template.loginEmail") }}*</label>
		</div>
		<span class="error-msg">{{ $translate("Ceres::Template.loginEnterConfirmEmail") }}</span>

		<div class="text-right">
			<button
				@click.prevent="validate"
				:disabled="isDisabled"
				class="btn btn-primary btn-lg btn-block btn-appearance"
				:class="buttonSizeClass"
				data-testing="guest-login-button"
			>
				{{ $translate("Eros::Template.loginNewNext") }}
				<icon icon="arrow-right" :loading="isDisabled"></icon>
			</button>
		</div>
	</form>
</template>

<script>
import { ButtonSizePropertyMixin } from "../../../../ceres/mixins/buttonSizeProperty.mixin";

import ApiService from "../../../../ceres/services/ApiService";
import ModalService from "../../../../ceres/services/ModalService";
import ValidationService from "../../../../ceres/services/ValidationService";
import { navigateTo } from "../../../services/UrlService";
import { isDefined, isNullOrUndefined } from "../../../../ceres/helper/utils";

export default {
	name: "guest-check",

	mixins: [ButtonSizePropertyMixin],

	props: {
		backlink: {
			type: String
		},
		initialEmail: {
			type: String,
			default: ""
		}
	},

	emits: ["has-account"],

	data() {
		return {
			email: "",
			isDisabled: false
		};
	},

	created() {
		if (!isNullOrUndefined(this.initialEmail) && this.initialEmail.length > 0) {
			this.email = this.initialEmail;
		}
	},

	mounted() {
		this.$nextTick(() => {
			// for old login view only (input in modal)
			if (!isNullOrUndefined(this.$refs.guestModal)) {
				this.$refs.guestModal.addEventListener("hidden.bs.modal", () => {
					this.email = "";
					ValidationService.unmarkAllFields(this.$refs.form);
				});
			}
		});
	},

	methods: {
		showModal() {
			ModalService.findModal(this.$refs.guestModal).show();
		},
		validate() {
			ValidationService.validate(this.$refs.form)
				.done(() => {
					this.authGuest();
				})
				.fail(invalidFields => {
					ValidationService.markInvalidFields(invalidFields, "error");
				});
		},

		authGuest() {
			this.isDisabled = true;

			ApiService.post("/rest/io/guest", { email: this.email })
				.done(() => {
					navigateTo(
						isDefined(this.backlink) && this.backlink.length
							? decodeURIComponent(this.backlink)
							: window.location.origin
					);
				})
				.fail(() => {
					this.isDisabled = false;
				});
		},
		checkExistingCustomer() {
			let mailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

			if (mailRegex.test(this.email)) {
				this.callCheck();
			}
		},
		callCheck() {
			this.isDisabled = true;

			ApiService.get("/rest/account-check", { mail: this.email })
				.done(response => {
					this.$emit("has-account", {
						hasAccount: response === true,
						email: this.email
					});
					this.isDisabled = false;
				})
				.fail(() => {
					this.isDisabled = false;
				});
		}
	}
};
</script>
